export default "__VITE_ASSET__V8EVTZSv__"